import React from 'react';
import Loader from 'components/Loader/Loader';
import { PricingPayload, ReportInterface, SpotInterface } from 'types';
import WidgetBox from '../widgets/WidgetBox';
import DynamicPricingUplift from './DynamicPricingUplift';
import CurrentRates from './CurrentRates';
import PriceGraphWrapper from './PriceGraphWrapper';
import LiveUpdateLabel from 'components/widgets/LiveUpdateLabel';
import { AuthorizedView, Roles } from 'components/Utilities/AuthorizedView';

type DynamicPricingWidgetProps = {
    spot: SpotInterface;
    multidayRates: PricingPayload[] | null;
    loadingRates: boolean;
    rateErrorMessage: string;
    report: ReportInterface | null;
    isReportLoading: boolean;
    updateReportsLoading: boolean;
};

function DynamicPricingWidget({
    spot,
    multidayRates,
    loadingRates,
    rateErrorMessage,
    report,
    isReportLoading,
    updateReportsLoading,
}: DynamicPricingWidgetProps): JSX.Element {
    return (
        <WidgetBox title="Dynamic Pricing" rightElement={<LiveUpdateLabel loading={updateReportsLoading} />}>
            <div>
                {loadingRates || isReportLoading ? (
                    <Loader centered />
                ) : (
                    <>
                        <AuthorizedView allowed={Roles.Admin}>
                            <DynamicPricingUplift report={report} />
                        </AuthorizedView>
                        <PriceGraphWrapper
                            rates={multidayRates}
                            errorMessage={rateErrorMessage}
                            timezone={spot.timezone}
                        />
                        <CurrentRates spot={spot} rates={multidayRates} />
                    </>
                )}
            </div>
        </WidgetBox>
    );
}

export default DynamicPricingWidget;
